
export default [
  {
    path: 'ventas',
    name: 'empresa.ventas',
    component: () => import('@/views/empresa/ventas/VentasEmpresaLayout.vue'),
    children: [
      {
        path: '',
        name: 'empresa.ventas.home',
        component: () => import('@/views/empresa/ventas/VentasEmpresaDash.vue'),
      },
      {
        path: 'conciliacion',
        name: 'empresa.ventas.conciliacion',
        component: () => import('@/views/empresa/ventas/reporte/ReporteVentaConciliacion.vue'),
      },
      {
        path: 'resumen',
        name: 'empresa.ventas.resumen2',
        component: () => import('@/views/empresa/ventas/VentasEmpresaResumen.vue'),
      },
      {
        path: 'resumen-diario',
        name: 'empresa.ventas.resumen.diario2',
        component: () => import('@/views/empresa/ventas/reporte/ResumenDiarioVenta.vue')
      },
      {
        path: 'periodo',
        name: 'empresa.ventas.periodo',
        component: () => import('@/views/reportes/ventas/reporte.ventas.por.periodo.vue'),
      },

      // 📋 Presupuestos
      {
        path: 'presupuestos',
        name: 'empresa.ventas.presupuesto.listado',
        component: () => import('@/views/empresa/ventas/presupuesto/PresupuestoEmpresaHome.vue'),
      },
      {
        path: 'presupuestos/nuevo',
        name: 'empresa.ventas.presupuesto.registrar',
        component: () => import('@/views/empresa/ventas/presupuesto/PresupuestoEmpresaRegistrar.vue'),
      },
      {
        path: 'presupuestos/:id',
        name: 'empresa.ventas.presupuesto.consultar',
        component: () => import('@/views/empresa/ventas/presupuesto/PresupuestoEmpresaConsultar.vue'),
      },
      {
        path: 'presupuestos/:id/editar',
        name: 'empresa.ventas.presupuesto.editar',
        component: () => import('@/views/empresa/ventas/presupuesto/PresupuestoEmpresaEditar.vue'),
      },

      // 🛒 Pedidos online
      {
        path: 'pedidos-online',
        name: 'empresa.ventas.pedidos-online.listado',
        component: () => import('@/views/empresa/ventas/pedido-online/PedidoOnlineEmpresaHome.vue'),
      },
      {
        path: 'pedidos-online/:id',
        name: 'empresa.ventas.pedidos-online.detalle',
        component: () => import('@/views/empresa/ventas/pedido-online/PedidoOnlineEmpresaDetalle.vue'),
      },

      // 📦 Órdenes de preparación
      {
        path: 'ordenes',
        name: 'empresa.ventas.orden.listado',
        component: () => import('@/views/empresa/ventas/orden/OrdenPreparacionEmpresaHome.vue'),
      },
      {
        path: 'ordenes/:id',
        name: 'empresa.ventas.orden.consultar',
        component: () => import('@/views/empresa/ventas/orden/OrdenPreparacionEmpresaConsultar.vue'),
      },

      // 🚚 Remitos
      {
        path: 'remitos',
        name: 'empresa.ventas.remito.listado',
        component: () => import('@/views/empresa/ventas/remito/RemitoVentaEmpresaHome.vue'),
      },
      {
        path: 'remitos/nuevo',
        name: 'empresa.ventas.remito.registrar',
        component: () => import('@/views/empresa/ventas/remito/RemitoVentaEmpresaRegistrar.vue'),
      },
      {
        path: 'remitos/:id',
        name: 'empresa.ventas.remito.consultar',
        component: () => import('@/views/empresa/ventas/remito/RemitoVentaEmpresaConsultar.vue'),
      },

      // 🧾 Facturas FC
      {
        path: 'facturas/:id',
        name: 'empresa.ventas.factura.consultar',
        component: () => import('@/views/empresa/ventas/factura/FacturaVentaEmpresaConsultar.vue'),
      },

      // 💰 Cobros
      {
        path: 'cobros',
        name: 'empresa.ventas.cobros',
        component: () => import('@/views/empresa/ventas/cobro/CobrarClienteEmpresa.vue'),
      },

      // 🧾 Cartera de cheques
      {
        path: 'cheques',
        name: 'empresa.ventas.cheques',
        component: () => import('@/views/empresa/ventas/cheques/ChequesEmpresa.vue'),
      },

      // ⚙️ Condiciones de pago
      {
        path: 'condiciones-pago',
        name: 'empresa.ventas.condiciones.pago',
        component: () => import('@/views/empresa/ventas/configuracion/CondicionesPagoEmpresa.vue'),
      },

      // 💲 Listas de precio
      {
        path: 'listas-precio',
        name: 'empresa.ventas.listas.precio',
        component: () => import('@/views/empresa/ventas/configuracion/ListasPrecioEmpresa.vue'),
      },
    ],
  },
];
